export default __webpack_public_path__ + "static/media/RecommendImageSmall.43d36b25.png";